<template>
  <o-view>
    <o-nav-bar title="Bus / tram / metro" :has-back-button="true" />
    <o-map />
    <o-block-list title="Kies een aanbieder">
      <o-list-item
        icon="brands/delijn"
        iconStyle="logo"
        label="De Lijn"
        link="/sales/ov/delijn"
      />
      <o-list-item
        icon="brands/mivb"
        iconStyle="logo"
        label="MIVB"
        link="/sales/ov/mivb"
      />
      <o-list-item icon="brands/tec" iconStyle="logo" label="Tec" />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'
import OBudgetPicker from '@/components/OBudgetPicker.vue'

export default {
  name: 'Bike',
  components: {
    OBudgetPicker,
    OMap
  }
}
</script>
